export const getFileName = (fileUrl: string) => {
  const url = new URL(fileUrl);
  const fileName = url.searchParams.get('name');
  return fileName ? decodeURIComponent(fileName) : null;
};
